export const defaultValues = {
	title: 'Remove All Favorites',
	descriptionTitle:
		"Ready to clear your favorites list? Just remember – once they're gone, they're gone for good.",
	descriptionContent:
		"You'll need to re-favorite products individually if you want to add them back.",
	remBtnTitle: 'Remove All Favorites',
	keepBtnTitle: 'Keep All Favorites'
};
